import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Github } from '../../assets/github-icon.svg';
import { ReactComponent as Blog } from '../../assets/blog-icon.svg';
import { ReactComponent as Linkedin } from '../../assets/linkedin-icon.svg';
import { ReactComponent as Email } from '../../assets/email-icon.svg';

const ContactBox = ({ lang, changeLang }) => {
  const contact = [
    { name: 'github', link: 'https://github.com/ekklesia11', icon: Github },
    {
      name: 'linkedin',
      link: 'https://linkedin.com/in/danielpark11',
      icon: Linkedin,
    },
    { name: 'blog', link: 'http://blog.hometowndeveloper.com', icon: Blog },
    { name: 'email', link: 'mailto:happyyquokka@gmail.com', icon: Email },
  ];

  return (
    <Container>
      <div className='word'>
        <span className='word-heading'>It always</span>
        <br />
        <span className='word-sub-heading'>
          seems impossible
          <br />
          until it's done.
        </span>
      </div>
      <div className='contact'>
        <div
          className='cta'
          onClick={() => {
            window.open('mailto:happyyquokka@gmail.com', '_blank');
          }}
        >
          <div className='cta-word'>Contact me</div>
          <div className='cta-icon'>
            <Email />
          </div>
        </div>
      </div>
      <div className='info'>
        {contact.map((data) => (
          <a
            href={data.link}
            target='_blank'
            rel='noopener noreferrer'
            key={data.name}
          >
            <data.icon
              fill={
                data.name === 'github' || data.name === 'blog'
                  ? '#f1f2f6'
                  : 'none'
              }
              stroke='#f1f2f6'
              width={data.name === 'linkedin' ? '20px' : '24px'}
              height={data.name === 'linkedin' ? '20px' : '24px'}
            />
          </a>
        ))}
      </div>
      <div className='copyright'>2023 © Daniel</div>
    </Container>
  );
};

const Container = styled.div`
  background-color: #000;
  text-align: center;
  padding: 200px 0 36px;

  .word {
    font-size: 50px;
    font-weight: 700;
    text-align: left;
    max-width: 380px;
    margin: 0 auto;

    .word-heading {
    }

    .word-sub-heading {
      color: #fff;
    }
  }

  .contact {
    display: flex;
    justify-content: center;
    margin: 48px 0;

    .cta {
      background: #34e89e;
      background: linear-gradient(45deg, #0f3443 10%, #34e89e 100%);
      width: 384px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 24px;
      border-radius: 32px;
      gap: 24px;
      color: #fff;
      transition: ease-out 0.2s;

      .cta-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 0 18px 1px rgba(52, 232, 158, 0.2);
        transform: translateY(-2px);

        .cta-word {
          text-shadow: 1px 1px 24px rgba(255, 255, 255, 0.2);
        }
      }
    }
  }

  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;

    a {
      width: 42px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: ease-out 0.2s;

      &:hover {
        transform: translateY(-8px);
      }
    }
  }

  .copyright {
    font-size: 12px;
    margin-top: 24px;
  }

  .language {
    font-size: 14px;
    margin-top: 24px;

    &:hover {
      cursor: pointer;
    }
  }

  @media only screen and (min-width: 769px) {
    .word {
      font-size: 64px;
      max-width: 768px;
    }
  }

  @media only screen and (min-width: 1025px) {
  }
`;

export default ContactBox;
